import React from 'react';

export default class SendMessagePopup extends React.Component{
  constructor(props){
    super(props);
  }

  componentDidMount(){

  }

  render(){
    const {props} = this;
    return(
      <div className="modal-popup">
        <div className="overlay">
          <div className="modal send-message-modal">
            <div className="content-wrap">
              <div className="icon-wrap"></div>
              <div className="close-button" onClick={props.closePopupCallback}>
                <span className="icon-cross-feather"></span>
              </div>
              <div className="content-sub-hdr">
                You must have a flight booked in order to confirm that you are traveling to the package destination
              </div>
              <div className="confirm-btn-wrap">
                <button className="btn orange" onClick={props.closePopupCallback}>Got it</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// app/browse_packages/send_message_popup/send_message_popup.jsx